.ansiDisplayContainer {
  position: relative;
  width: 100%;
}

.ansiDisplay {
  font-family: monospace;
  white-space: pre-wrap;
  line-height: normal;
  --ansiBlack: #000000;
  --ansiRed: #cd3131;
  --ansiGreen: #00bc00;
  --ansiYellow: #949800;
  --ansiBlue: #0451a5;
  --ansiMagenta: #bc05bc;
  --ansiCyan: #0598bc;
  --ansiWhite: #555555;
  --ansiBrightBlack: #666666;
  --ansiBrightRed: #cd3131;
  --ansiBrightGreen: #14ce14;
  --ansiBrightYellow: #b5ba00;
  --ansiBrightBlue: #0451a5;
  --ansiBrightMagenta: #bc05bc;
  --ansiBrightCyan: #0598bc;
  --ansiBrightWhite: #a5a5a5;
}

.ansiDisplayRaw {
  margin: 0;
  white-space: pre-wrap;
}

:global(.dark-mode) .ansiDisplay {
  --ansiBlack: #000000;
  --ansiRed: #cd3131;
  --ansiGreen: #0dbc79;
  --ansiYellow: #e5e510;
  --ansiBlue: #2472c8;
  --ansiMagenta: #bc3fbc;
  --ansiCyan: #11a8cd;
  --ansiWhite: #e5e5e5;
  --ansiBrightBlack: #666666;
  --ansiBrightRed: #f14c4c;
  --ansiBrightGreen: #23d18b;
  --ansiBrightYellow: #f5f543;
  --ansiBrightBlue: #3b8eea;
  --ansiBrightMagenta: #d670d6;
  --ansiBrightCyan: #29b8db;
  --ansiBrightWhite: #e5e5e5;
}

@keyframes ansi-display-run-blink {
  50% {
    opacity: 0;
  }
}
